import React from 'react';
import * as Yup from 'yup';
import ReactTooltip from 'react-tooltip';
import { Loading } from '../../components';

import { AjaxForm, AddressFieldset } from '../../forms/index.jsx';
import { FormHelper, ValidationHelper } from '../../helpers/index.js';
import { FieldGroup } from '../../components';

export function MerchantOverview({ merchant, afterSubmit, submitLabel = 'Save', submitClassName = '' }) {
  if (!merchant) {
    return <Loading />;
  }

  const fields = [
    'avatar_file_id',
    'gender',
    'first_name', 'last_name',
    'nationality_id', 'birth_date',
    'email', 'phone',
    'address',
    'store_name', 'store_link',
  ];
  const requiredFields = ['gender', 'first_name', 'last_name', 'nationality_id', 'store_name', 'store_link'];

  const formProps = {
    method: merchant ? 'put' : 'post',
    url: merchant ? `/api/users/${merchant.id}` : '/api/users/pre-register',
    fields,
    validationSchema: ValidationHelper.schema(requiredFields, fields, {
      email: Yup
        .string().nullable().email()
        .test('email', 'Either Email or Phone is mandatory', async (email, ctx) => {
          const { phone } = ctx.parent;

          return !!(email || phone);
        }),
      phone: Yup
        .string().nullable()
        .test('phone', 'Either Phone or Email is mandatory', async (phone, ctx) => {
          const { email } = ctx.parent;

          return !!(phone || email);
        }),
      store_name: Yup
        .string().required('Store name is mandatory'),
      store_link: Yup
        .string().required('Store link is mandatory').url()
    }),
    initialValues: FormHelper.initialValues(fields, {
      ...merchant,
      ...(merchant?.merchant_store || {}),
    }),
    requiredFields: [],
    submitClassName,
    submitLabel,
    afterSubmit,
    showErrorNextToSubmit: true,
  };

  return (
    <div className="overview">
      <AjaxForm {...formProps}>
        <div className="row">
          <div className="col-md-3 pr-16">
            <FieldGroup
              name="avatar_file_id"
              type="avatar"
            />
          </div>
          <div className="col-md-3 ml-15">
            <FieldGroup
              name="gender"
              type="radio"
              options={[
                { id: 'men', name: 'MR' },
                { id: 'women', name: 'MS' }
              ]}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 pr-16">
            <FieldGroup
              placeholder="First Name"
              name="first_name"
            />

            <FieldGroup
              placeholder="Last Name"
              name="last_name"
            />

            <FieldGroup
              placeholder="Nationality"
              name="nationality_id"
              type="nationality"
            />

            <FieldGroup
              placeholder="Date of birth (DD/MM/YYYY)"
              name="birth_date"
              type="masked"
              mask="99/99/9999"
            />

            <FieldGroup
              placeholder="Email"
              type="email"
              name="email"
            />
          </div>

          <div className="col-md-6">
            <FieldGroup
              placeholder="Mobile"
              type="phone"
              name="phone"
              tooltip="Mobile"
            />

            <ReactTooltip />
            <AddressFieldset nameObject='address' />
          </div>
          <div className="col-md-6 pr-16">
            <FieldGroup
              type="text"
              placeholder="Store name"
              name="store_name"
            />
          </div>
          <div className="col-md-6 pr-16">
            <FieldGroup
              type="text"
              placeholder="Store link"
              name="store_link"
            />
          </div>
        </div>
      </AjaxForm>
    </div>
  );
}

